<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title" [xdaTranslate]="'SDE_JOB_HISTORY'"></div>
    <div class="modal-close">
      <button
        type="button"
        class="modal-close-btn"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true" class="xgl-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body p-0" tabindex="-1">
    <div class="workflow-info-wrapper d-flex align-items-center">
      <div
        class="workflow-info-icon-name-wrapper d-flex align-items-center flex-grow-1">
        @if (workflow.icon?.image) {
          <img class="workflow-image" [src]="workflow.icon?.image" />
        } @else {
          <div
            class="workflow-image {{
              workflow.icon?.color
            }} text-center align-middle d-flex align-items-center justify-content-center">
            <div class="{{ workflow.icon?.glyph }} xglsize-32"></div>
          </div>
        }
        <span
          class="workflow-name"
          [ngbTooltip]="workflow.name"
          [disableTooltip]="workflow.name.length < 18"
          triggers="hover"
          >{{
            workflow.name.length > 18
              ? (workflow.name | slice: 0 : 18) + '...'
              : workflow.name
          }}</span
        >
      </div>
      @if (jobs && jobs.length) {
        <button
          class="xrx-btn btn-secondary remove-selected"
          [xdaTranslate]="'SDE_REMOVE_SELECTED'"
          [disabled]="!anySelected"
          (click)="removeSelectedJobs()"></button>
      }
    </div>
    @if (jobs && jobs.length) {
      <div class="job-history-wrapper">
        <span class="flex-grow-1 select-all-label title">{{
          selectAllLabel
        }}</span>
        <ul
          id="job-history"
          class="list-group xrx-list-group"
          aria-multiselect="true"
          role="listbox"
          aria-labelledby="list-group-label">
          <li
            id="list-group-label"
            class="xrx-section-header align-items-center d-flex xrx-section-header">
            <xrx-checkbox
              class="all-job-checkbox"
              [name]="'all-job-checkbox'"
              [(checkBoxValue)]="selectAll"
              [(isPartial)]="isPartial"
              (toggle)="toggleAll($event)"
              [label]="'SDE_JOBS'"></xrx-checkbox>
          </li>
          @for (
            job of jobs | slice: (page - 1) * pageSize : page * pageSize;
            track job
          ) {
            <li
              role="option"
              class="list-group-item list-group-item-action"
              (click)="rowClicked(job)"
              longTouch
              (longTouch)="report(job)">
              @if ($any(job).hasHeader) {
                <div class="list-group-sub-header">
                  <span>{{ $any(job).occurrenceString }}</span>
                </div>
              }
              <span class="row-content d-flex align-items-center">
                <span class="check">
                  <xrx-checkbox
                    class="job-checkbox"
                    [(checkBoxValue)]="$any(job).checked"
                    (toggle)="onChecked($event, job)"
                    [name]="'job-checkbox'"
                    stop-event-propagation></xrx-checkbox>
                </span>
                <span class="job-info d-flex flex-column flex-grow-1">
                  <span class="file-name">{{ $any(job).fileName }}</span>
                  <span class="pages">{{ $any(job).pageCountString }}</span>
                  <span
                    class="submitted"
                    [xdaTranslate]="'SDE_SUBMITTED_FMTSTR'"
                    [formatValues]="$any(job).submitted"></span>
                </span>
                @if ($any(job).status[0].state == statusStates.Completed) {
                  <span class="job-status success"
                    ><span class="xgl-checkmark_circle_break"></span
                  ></span>
                }
                @if ($any(job).status[0].state == statusStates.Errored) {
                  <span class="job-status error"
                    ><span class="xgl-alert"></span
                  ></span>
                }
              </span>
              @if ($any(job).status[0].state == statusStates.Errored) {
                <span class="error-text">{{
                  getErrorMessage($any(job).status)
                }}</span>
              }
            </li>
          }
        </ul>
        <div class="pagination-wrapper">
          @if (jobs && jobs.length && displayPagination) {
            <xrx-pagination
              [(page)]="page"
              [(pageSize)]="pageSize"
              [initialPageSize]="initialPageSize"
              [showPageSizeList]="false"
              [collectionSize]="jobs.length"
              class="d-flex justify-content-center justify-content-sm-end">
            </xrx-pagination>
          }
        </div>
      </div>
    }
    <div
      [ngClass]="{ 'd-none': !showActivity }"
      class="activty-wrapper flex-center">
      <span class="xrx-activity-indicator ai-md ai-spin"></span>
    </div>
    @if (jobs && jobs.length < 1 && jobsReturned) {
      <div class="no-jobs-wrapper">
        <div class="align-items-center d-flex flex-column">
          <i class="no-jobs-glyph xgl-history"></i>
          <h4 class="h4" [xdaTranslate]="'SDE_AUTOMATED_WORKFLOW_NO'"></h4>
        </div>
      </div>
    }
  </div>
</div>
